import { PageLayoutFull } from "../layouts/PageLayoutFull";
import { ListBondsTable } from "./list/ListBondsTable";

export const BondsDashboardScreen = () => {
  return (
    <PageLayoutFull>
      <ListBondsTable />
    </PageLayoutFull>
  );
};
